import { Route, Redirect } from "react-router-dom";
import Coupons from "../pages/coupons/Coupons";

const CouponsRoute = ({ isLogged, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLogged ? (
        <Coupons />
      ) : (
        <Redirect
          exact
          to={{
            pathname: "/",
            state: {
              from: props.location,
            },
          }}
        />
      )
    }
  />
);

export default CouponsRoute;
